import React from 'react';
import HeaderOne from '../common/header/HeaderOne';
import HeroThree from '../components/hero/HeroThree';
import FeatureOne from '../components/features/FeatureOne';
import ServiceOne from '../components/services/ServiceOne';
import AboutOne from '../components/about/AboutOne';
import ProjectOne from '../components/project/ProjectOne';
import WhyChooseOne from '../components/why-choose-us/WhyChooseOne';
import WorkPerformanceOne from '../components/work-performance/WorkPerformanceOne';
import FeatureFive from '../components/features/FeatureFive';
import TestimonialOne from '../components/testimonial/TestimonialOne';
import BlogThree from '../components/blog/BlogThree';
import BrandOne from "../components/brand/BrandOne";
import FooterOne from '../common/footer/FooterOne';

const HomeThree = () => {
    return (
        <>
            <HeaderOne />
            <HeroThree />
            <FeatureOne />
            <ServiceOne />
            <AboutOne />
            <ProjectOne />
            <WhyChooseOne />
            <WorkPerformanceOne />
            <FeatureFive />
            <TestimonialOne />
            <BlogThree />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default HomeThree;